import { render, staticRenderFns } from "./service_quest.vue?vue&type=template&id=c2a1f758&"
import script from "./service_quest.vue?vue&type=script&lang=js&"
export * from "./service_quest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports